export default __webpack_public_path__ + "static/media/cai-design01.aa0c86e1.jpg";